export const FACE_COVER_TARGETS_CONFIG_V1 = [
  {
    key: 'facecover',
    titleI18nKey: 'videoAnalytics:form.facecover.targets.facecover',
    thresholdLabelI18nKey: 'videoAnalytics:form.facecover.facecover_threshold.label',
    thresholdTooltipI18nKey: 'videoAnalytics:form.facecover.facecover_threshold.tooltip',
    thresholdField: 'facecover_threshold',
  },
];

export const FACE_COVER_TARGETS_CONFIG_V2 = [
  {
    key: 'balaclava',
    titleI18nKey: 'videoAnalytics:form.facecover.targets.balaclava',
    thresholdLabelI18nKey: 'videoAnalytics:form.facecover.balaclava_threshold.label',
    thresholdTooltipI18nKey: 'videoAnalytics:form.facecover.balaclava_threshold.tooltip',
    thresholdField: 'balaclava_threshold',
  },
  {
    key: 'niqab',
    titleI18nKey: 'videoAnalytics:form.facecover.targets.niqab',
    thresholdLabelI18nKey: 'videoAnalytics:form.facecover.niqab_threshold.label',
    thresholdTooltipI18nKey: 'videoAnalytics:form.facecover.niqab_threshold.tooltip',
    thresholdField: 'niqab_threshold',
  },
  {
    key: 'other',
    titleI18nKey: 'videoAnalytics:form.facecover.targets.other',
    thresholdLabelI18nKey: 'videoAnalytics:form.facecover.other_threshold.label',
    thresholdTooltipI18nKey: 'videoAnalytics:form.facecover.other_threshold.tooltip',
    thresholdField: 'other_threshold',
  },
];

export const FACE_COVER_TARGETS_CONFIG_BY_VERSION = {
  v1: FACE_COVER_TARGETS_CONFIG_V1,
  v2: FACE_COVER_TARGETS_CONFIG_V2,
};
